import TopNDropdownItem from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown-item/TopNDropdownItem/TopNDropdownItem";

export default class TopNSelectionItem extends TopNDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.top-n.selected",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
